// Backend returns absolute image URLs pointing at its own domain
// (e.g. https://car.dev.navi.agency/generation/xxx.webp). Requesting that
// domain directly from the browser bypasses the routeRules proxy in
// nuxt.config.js, so we rewrite it back to a relative path here and let the
// site's own domain serve it (proxied through to the backend).
export const getImage = (src, { baseURL } = {}) => {
  if (baseURL && typeof src === 'string' && src.startsWith(baseURL)) {
    const rest = src.slice(baseURL.length);
    return { url: rest.startsWith('/') ? rest : `/${rest}` };
  }
  return { url: src };
};
